import * as types from './mutation-types'
import {cacheManager} from "@/services/cacheManagerjs";

export const generalInformation = ({commit, dispatch, state}) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/society/infos')
            .then((response) => {
                commit(types.GET_COMPANY_INFOS, response.data)
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}


export const loadCurrencies = ({commit, dispatch, state}) => {
    return new Promise((resolve, reject) => {
        cacheManager.fetch('get/currencies/collection', state.currencies)
            .then((response) => {
                if(!response.fromState) commit(types.GET_CURRENCIES, response.data)
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}



